export default __webpack_public_path__ + "static/media/Faithsteel.201c087c.jpg";